import React, { Component } from "react";
import PropTypes from "prop-types";

import { Mutation } from "react-apollo";

import { Button, Fieldset, Field, Control } from "rbx";

import Section from "../Section";

import { CREATE_USER_GROUP_MUTATION } from "../../graphql/UserGroups/UserGroups.graphql";
import { ourToast as toast } from "../../utils";

import UserGroupForm from "./UserGroupForm";

class AddUserGroupForm extends Component {
  state = {
    GroupId: "",
    Name: "",
    Description: "",
    CompanyId: localStorage.getItem("user_company"),
    Active: true
  };

  onChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value });
  };

  render() {
    const { Active, GroupId, Name, Description, CompanyId } = this.state;
    const { setModalOpen } = this.props;

    return (
      <Mutation
        mutation={CREATE_USER_GROUP_MUTATION}
        refetchQueries={["ALL_USER_GROUPS_QUERY"]}
        variables={{
          data: {
            GroupId,
            Name,
            Description,
            CompanyId,
            Active
          }
        }}
      >
        {(createUserGroup, { loading, error }) => (
          <Section title="Add User Group">
            <form
              id="add-user-group"
              onSubmit={async e => {
                e.preventDefault();
                try {
                  await createUserGroup();
                  setModalOpen(false);
                  toast.success("User Group created successfully.");
                } catch (err) {
                  toast.error("Error creating User Group.");
                }
              }}
            >
              <Fieldset disabled={loading}>
                <UserGroupForm
                  adding
                  inputs={{
                    GroupId,
                    Name,
                    Description,
                    CompanyId,
                    Active
                  }}
                  onChange={this.onChange}
                />
                <hr />
                <Field kind="group">
                  <Control>
                    <Button color="primary" type="submit">
                      Submit
                    </Button>
                  </Control>
                  <Control>
                    <Button type="button" onClick={() => setModalOpen(false)}>
                      Cancel
                    </Button>
                  </Control>
                </Field>
              </Fieldset>
            </form>
          </Section>
        )}
      </Mutation>
    );
  }
}

AddUserGroupForm.propTypes = {
  setModalOpen: PropTypes.func
};
export default AddUserGroupForm;
